import { AccessPermissionModuleNames, AccessPermissionModules } from "Data";
import { getPermissionPath } from "Utils";
import { fetchPost, jsonToQueryParam, fetchGet } from "./CommonServiceUtils";
import Constants from "../Constants";

const BASE_URL = `${Constants.BASE_URL}loyaltyservice/productcatalogues`;

const getProductCatalogues = (queryObj = {}) => {
    return fetchGet(
        `${BASE_URL}?${jsonToQueryParam(queryObj)}`,
        true,
        getPermissionPath(
            AccessPermissionModuleNames.PRODUCT,
            AccessPermissionModules[AccessPermissionModuleNames.PRODUCT].actions
                .ListProducts
        )
    );
};

const exportProductCatalogues = (payload = {}) => {
    return fetchPost(
        `${BASE_URL}/export`,
        payload,
        true,
        getPermissionPath(
            AccessPermissionModuleNames.PRODUCT,
            AccessPermissionModules[AccessPermissionModuleNames.PRODUCT].actions
                .ExportProducts
        )
    );
};

export { getProductCatalogues, exportProductCatalogues };
